import { Card, CardContent, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React from 'react';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > div': {
      display: 'inline-block',
      padding: '1rem',
    },
  },
  fullHeight: {
    height: '100vh',
  },
  muiCardContentRoot: {
    '&:last-child': {
      paddingBottom: 'inherit',
    },
  },
}));

interface Props {
  naked?: boolean;
  fullHeight?: boolean;
}

const Loading: React.FC<Props> = ({ naked, fullHeight }) => {
  const classes = useStyles();
  return (
    <div className={classnames(classes.wrapper, { [classes.fullHeight]: fullHeight })}>
      <Card variant={naked ? 'elevation' : 'outlined'} elevation={naked ? 0 : 1}>
        <CardContent classes={{ root: classes.muiCardContentRoot }}>
          <CircularProgress />
        </CardContent>
      </Card>
    </div>
  );
};
export default Loading;
